"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgStar = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_STAR", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "m8 3.183 1.068 1.854a3.122 3.122 0 0 0 1.964 1.49l2.018.489-1.358 1.634a3.344 3.344 0 0 0-.75 2.41l.18 2.156-1.909-.844a2.989 2.989 0 0 0-2.426 0l-1.908.844.18-2.155a3.344 3.344 0 0 0-.75-2.411L2.95 7.016l2.018-.489a3.122 3.122 0 0 0 1.964-1.49L8 3.183ZM8.888.525c-.403-.7-1.373-.7-1.776 0L5.155 3.92a1.04 1.04 0 0 1-.654.496l-3.697.895C.042 5.496-.258 6.46.254 7.076l2.488 2.994c.184.221.274.511.25.803l-.328 3.949c-.068.813.718 1.41 1.437 1.09l3.495-1.545a.996.996 0 0 1 .808 0l3.495 1.546c.72.318 1.505-.278 1.437-1.091l-.328-3.949a1.115 1.115 0 0 1 .25-.803l2.487-2.994c.513-.616.213-1.58-.549-1.764L11.5 4.417a1.041 1.041 0 0 1-.654-.496L8.888.525Z" }))); };
exports.default = SvgStar;
